<template>
  <div :class="['mode-button-box', {'is-show' : isShowMode}]">
    <button type="button"
            ref="dashboardBtn"
            :class="['mode-button dashboard', { 'is-hover': !buttonDisabled.dashboard &&  hoveringType === 'dashboard' }]"
            :disabled="buttonDisabled['dashboard']"
            @mouseenter="onModeHover($event, 'dashboard')"
            @mouseleave="onModeLeave('dashboard')"
            @mousedown="onModeMouseDown('dashboard')"
            @mouseup="onModeMouseUp('dashboard')"
    >
      <span class="left">
        <i class="icon icon--mode-dashboard"></i>
        <i class="label" v-html="$t('dashboard.ai.dashboard.button.label')"></i>
      </span>
      <template v-if="buttonPress.dashboard">
        <svg xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104" fill="none">
          <g filter="url(#filter0_f_51_2579)">
            <path d="M72.7002 51.7C72.7002 40.102 63.2982 30.7 51.7002 30.7C40.1022 30.7 30.7002 40.102 30.7002 51.7C30.7002 63.2979 40.1022 72.7 51.7002 72.7C63.2982 72.7 72.7002 63.2979 72.7002 51.7ZM94.7002 51.7C94.7002 75.4482 75.4484 94.7 51.7002 94.7C27.952 94.7 8.7002 75.4482 8.7002 51.7C8.7002 27.9517 27.952 8.69995 51.7002 8.69995C75.4484 8.69995 94.7002 27.9517 94.7002 51.7Z" fill="#EC0047"/>
          </g>
          <defs>
            <filter id="filter0_f_51_2579" x="0.000195503" y="-4.86374e-05" width="103.4" height="103.4" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
              <feGaussianBlur stdDeviation="4.35" result="effect1_foregroundBlur_51_2579"/>
            </filter>
          </defs>
        </svg>
      </template>
    </button>
    <button type="button"
            ref="dashboardHellBtn"
            :class="['mode-button dashboardHell', { 'is-hover':!buttonDisabled.dashboardHell &&  hoveringType === 'dashboardHell'}]"
            :disabled="buttonDisabled['dashboardHell']"
            @mouseenter="onModeHover($event, 'dashboardHell')"
            @mouseleave="onModeLeave('dashboardHell')"
            @mousedown="onModeMouseDown('dashboardHell')"
            @mouseup="onModeMouseUp('dashboardHell')"
    >
      <span class="left">
        <i class="icon icon--mode-dashboardHell"></i>
        <i class="label" v-html="$t('dashboard.ai.dashboardHell.button.label')"></i>
      </span>
      <template v-if="buttonPress.dashboardHell">
        <svg xmlns="http://www.w3.org/2000/svg" width="104" height="104" viewBox="0 0 104 104" fill="none">
          <g filter="url(#filter0_f_51_2579)">
            <path d="M72.7002 51.7C72.7002 40.102 63.2982 30.7 51.7002 30.7C40.1022 30.7 30.7002 40.102 30.7002 51.7C30.7002 63.2979 40.1022 72.7 51.7002 72.7C63.2982 72.7 72.7002 63.2979 72.7002 51.7ZM94.7002 51.7C94.7002 75.4482 75.4484 94.7 51.7002 94.7C27.952 94.7 8.7002 75.4482 8.7002 51.7C8.7002 27.9517 27.952 8.69995 51.7002 8.69995C75.4484 8.69995 94.7002 27.9517 94.7002 51.7Z" fill="#EC0047"/>
          </g>
          <defs>
            <filter id="filter0_f_51_2579" x="0.000195503" y="-4.86374e-05" width="103.4" height="103.4" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
              <feGaussianBlur stdDeviation="4.35" result="effect1_foregroundBlur_51_2579"/>
            </filter>
          </defs>
        </svg>
      </template>
    </button>
    <transition name="tooltip-fade">
      <div
        v-if="tooltip.visible"
        class="ai-tooltip"
        :class="[tooltip.mode, {'lack': tooltip.jamLack}, {'jam': tooltip.noJam}, {'is-open': tooltip.visible}]"
        :style="{ top: tooltip.y + 'px', left: tooltip.x + 'px' }"
        @mouseenter="tooltipInside = true"
        @mouseleave="onTooltipLeave"
      >
        <template v-if="tooltip.noJam || tooltip.jamLack">
          <p v-html="$t('dashboard.ai.jamTooltip')"></p>
          <button class="charge-button" @click="onChargeJam">
            <i class="icon icon--plus-blue2"></i>
            <span>{{ $t('dashboard.ai.chargeJam') }}</span>
          </button>
        </template>
        <template v-else>
          <span v-html="$t(`dashboard.ai.${tooltip.mode}.desc`)"></span>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
export default {
  name: 'DashboardCreateButton',
  props: {
    isShowMode: {
      type: Boolean,
      default: false
    },
    remainJam: {
      default: 0
    },
    reportJamPrice: {
      default: 0
    }
  },
  data () {
    return {
      buttonDisabled: {
        dashboard: true,
        dashboardHell: true
      },
      buttonActive: {
        dashboard: false,
        dashboardHell: false
      },
      hoveringType: null,
      tooltip: {
        visible: false,
        mode: null,
        x: 0,
        y: 0
      },
      tooltipInside: false,
      hoveringButton: false,
      buttonPress: {
        dashboard: false,
        dashboardHell: false
      },
      selectedType: ''
    }
  },
  watch: {
    isShowMode: {
      immediate: true,
      handler (val) {
        if (val) {
          this.buttonDisabled = { dashboard: false, dashboardHell: false }
        } else {
          this.buttonDisabled = { dashboard: false, dashboardHell: false }
        }
      }
    }
  },
  methods: {
    onModeMouseDown (type) {
      this.closeTooltip()
      this.buttonPress = {
        dashboard: type === 'dashboard',
        dashboardHell: type === 'dashboardHell'
      }
    },
    onModeMouseUp (type) {
      this.buttonPress = {
        dashboard: false,
        dashboardHell: false
      }

      this.onCreateReport(type)
    },
    onModeHover (event, type) {
      if (this.buttonActive.dashboard || this.buttonActive.dashboardHell) return

      this.hoveringButton = true
      this.hoveringType = type
      this.openTooltip(event, type)

      for (const key in this.buttonDisabled) {
        this.buttonDisabled[key] = key !== type
      }
    },
    onModeLeave (type) {
      if (this.buttonActive.dashboard || this.buttonActive.dashboardHell) return
      this.buttonPress = {
        dashboard: false,
        dashboardHell: false
      }
      if (!this.tooltip.noJam && !this.tooltip.jamLack) {
        this.closeTooltip()
        for (const key in this.buttonDisabled) {
          this.buttonDisabled[key] = false
        }
      }

      this.hoveringButton = false
      if (this.hoveringType === type) {
        this.hoveringType = null
      }

      setTimeout(() => {
        if (!this.hoveringButton && !this.tooltipInside) {
          this.closeTooltip()
        }
      }, 50)
    },
    onCreateReport (type) {
      this.buttonActive = {
        dashboard: type === 'dashboard',
        dashboardHell: type === 'dashboardHell'
      }
      this.selectedType = type
      this.closeTooltip()
      this.$emit('startAnimation', this.buttonActive)
      this.buttonActive = {
        dashboard: false,
        dashboardHell: false
      }

      this.$emit('requestPayment', this.selectedType)
    },
    openTooltip (event, mode) {
      const rect = event.currentTarget.getBoundingClientRect()
      const parentRect = event.currentTarget.offsetParent.getBoundingClientRect()

      this.tooltip = {
        visible: true,
        mode,
        x: rect.left - parentRect.left + rect.width / 2,
        y: rect.top - parentRect.top - 9
      }
    },
    closeTooltip () {
      this.tooltip.visible = false
    },
    onTooltipLeave () {
      this.tooltipInside = false
      if (this.buttonActive.dashboard || this.buttonActive.dashboardHell) return

      if (this.tooltip.noJam || this.tooltip.jamLack) {
        setTimeout(() => {
          if (!this.tooltipInside && !this.hoveringButton) {
            this.closeTooltip()
          }
        }, 50)
      }
    },
    onChargeJam () {
      EventBus.$emit('onChargeJam', this.remainJam)
    }
  }
}
</script>

<style scoped lang="scss">
.tooltip-fade-enter-active,
.tooltip-fade-leave-active {
  transition: opacity 0.18s ease-out, transform 0.18s ease-out;
}

.tooltip-fade-enter {
  opacity: 0;
}

.tooltip-fade-enter-to {
  opacity: 1;
}

.tooltip-fade-leave {
  opacity: 1;
}

.tooltip-fade-leave-to {
  opacity: 0;
}
@keyframes activeButton {
  0% {
    transform: scale(1, 1);
  }
  3.57143% {
    transform: scale(1, 1);
    animation-timing-function:
      cubic-bezier(0, 0, 0.58, 1);
  }
  7.14286% {
    transform:  scale(0.8, 0.8);
  }
  10.7143% {
    transform:  scale(0.77, 0.77);
    animation-timing-function:
      cubic-bezier(0.42, 0, 1, 1);
  }
  14.2857% {
    transform:  scale(1.3, 1.3);
    animation-timing-function:
      cubic-bezier(0.42, 0, 0.58, 1);
  }
  21.4286% {
    transform:  scale(0.9, 0.9);
    animation-timing-function:
      cubic-bezier(0.42, 0, 0.58, 1);
  }
  28.5714% {
    transform:  scale(1.2, 1.2);
    animation-timing-function:
      cubic-bezier(0.42, 0, 0.58, 1);
  }
  35.7143% {
    transform:  scale(0.97, 0.97);
  }
  42.8571% {
    transform:  scale(1.05, 1.05);
    animation-timing-function:
      cubic-bezier(0.42, 0, 0.58, 1);
  }
  50% {
    transform:  scale(0.99, 0.99);
  }
  57.1429% {
    transform:  scale(1.02, 1.02);
    animation-timing-function:
      cubic-bezier(0.42, 0, 0.58, 1);
  }
  64.2857% {
    transform: scale(1, 1);
  }
  75% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1, 1);
  }
}

.mode-button-box {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
  //position: relative;
  position: absolute;
  inset: 0;
  transform: translateY(-5px);
  &.is-show {
    transform: translateY(0px);
  }
  .ai-tooltip {
    width: 218px;
    position: absolute;
    top: -9px;
    left: 50%;
    transform: translate(-50%, -100%);
    padding: 16px 20px;
    margin-bottom: 10px;
    border-radius: 8px;
    background-color: #fff;
    z-index: 2;
    box-sizing: border-box;
    box-shadow:
      0 8px 15px 0 rgba(0, 0, 0, 0.16),
      0 0 0 1px rgba(0, 0, 0, 0.16);
    text-align: left;
    color: #444;
    font-size: 13px;
    font-weight: 400;
    line-height: 150%;

    &:lang(ko){
    word-break: keep-all;
    }

    &.lack {
      width: 169px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }

    &.jam {
      width: 169px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }

    & /deep/ {
      .accent {
        font-size: 13px;
        color: #444;
        font-weight: 600;
        line-height: 150%;

        &.red {
          font-weight: 500;
          color: #EC0047
        }

        .orange {
          color: #FC6A00
        }
      }
    }

    .charge-button {
      @include flexXYcenter;
      gap: 4px;
      color: #0074FF;
    }

    &::after {
      content: '';
      position: absolute;
      width: 10px;
      height: 10px;
      background-color: inherit;
      margin: -1px;
      top: 100%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-45deg);
      box-shadow: -1px 1px 0 0 rgba(0, 0, 0, 0.16);
    }
  }
  .mode-button {
    padding: 10px 16px 10px 8px;
    border-radius: var(--Number-num_30, 6px);
    background: linear-gradient(180deg, #FFF 0%, #F4F4F4 100%);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08), 0 20px 16px -12px rgba(0, 0, 0, 0.12);
    display: flex;
    align-items: center;
    gap: 1.5px;
    flex: 1;
    opacity: 1;
    transition: opacity 0.3s ease-in,transform 0.3s ease-in;
    position: relative;
    overflow: hidden;

    &:active {
      border-radius: var(--Radius-Button-bt_radius_l, 6px);
      background: linear-gradient(180deg, #CCC 0%, #E2E2E2 37.02%, #FCFCFC 76.44%);
      box-shadow: -1px -1px 1px 0 rgba(0, 0, 0, 0.44), -2px -2px 3px 0 rgba(255, 255, 255, 0.85) inset, 2px 2px 3px 0 rgba(0, 0, 0, 0.44) inset;

      .left .icon {
        background-color: transparent;
      }
    }

    &.is-hover:not(:disabled, .hover-lock, .no-jam) {
      .left {
        .icon {
          background-color: rgba(0, 0, 0, 0.12);
        }
      }
    }

    &.is-hidden {
      pointer-events: none;
      visibility: hidden;
    }

    &.dashboard {
      .left {
        .label {
          color: #2F2F2F;
        }
      }
    }

    &.dashboardHell {
      .left {
        .label {
          color: #EC0047;
        }
      }
    }

    .line {
      width: 1px;
      height: 28px;
      display: block;
      background-color: #ccc;
    }

    .left {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      text-align: left;
      flex: 1 1 104px;

      .label {
        color: #2F2F2F;
        font-size: 16.5px;
        font-weight: 600;
        line-height: 100%;
      }

      .icon {
        transition: all 0.3s ease-in-out;
        border-radius: 4px;
      }
    }

    .right {
      gap: 4px;
      align-items: center;
      display: flex;
      justify-content: center;
      flex-basis: 36px;

      .label {
        color: #FC6A00;
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
      }

      .desc {
        color: #2F2F2F;
        font-size: 13px;
        font-weight: 600;
        line-height: 1
      }
    }

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(1);
      animation: pulse-strong 1.3s ease-out forwards,
      pulse-weak 1.3s ease-out forwards 1.3s;
    }
  }

  @keyframes pulse-strong {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    100% {
      transform: translate(-50%, -50%) scale(2.5);
      opacity: 0;
    }
  }

  @keyframes pulse-weak {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.16;
    }
    100% {
      transform: translate(-50%, -50%) scale(2.5);
      opacity: 0;
    }
  }
}

</style>
